import React from 'react';
import Flower from './Flower';
import Leaves from './Leaves';
import { typeFlowerColors } from '../constants/constants';
import { Box, Chip, ThemeProvider, Typography } from '@mui/material';
import { appTheme } from '../constants/theme';

const FlowerTable = ({ isPresentationPage = false }) => {
  // Three main talk move types with colored flowers
  const talkMoves = [
    { type: 'making_claim', label: 'Making a Claim', color: typeFlowerColors.making_claim, colorName: 'blue' },
    { type: 'relating', label: 'Relating to Another Student', color: typeFlowerColors.relating, colorName: 'yellow' },
    { type: 'providing_evidence', label: 'Providing Evidence', color: typeFlowerColors.providing_evidence, colorName: 'purple' },
    { type: 'any_talk', label: 'Any Student Talk', color: null, colorName: 'green' }
  ];

  const generateAriaLabel = () => {
    const descriptions = talkMoves.map(move => {
      const icon = move.type === 'any_talk' ? `${move.colorName} leaf` : `${move.colorName} flower`;
      return `${move.label} (${icon})`;
    });
    return `Legend showing four types of student talk moves: ${descriptions.join(', ')}`;
  };
  
  if (isPresentationPage) {
    return (
      <ThemeProvider theme={appTheme}>
      <Box
        sx={{
          mt: 1,
          p: 2,
          display: 'flex',
          alignItems: 'center',
          gap: 2,
          flexWrap: 'wrap',
        }}
        role="figure"
        aria-label={generateAriaLabel()}
      >
        <Box sx={{ fontWeight: 600, fontSize: '0.875rem',   flexShrink: 0, alignSelf: 'flex-start',
  paddingTop: '2px',  }}>
          Legend
        </Box>

        <Box sx={{
          display: 'grid',
          gridTemplateColumns: { xs: '1fr', sm: '1fr 1fr' },   
          columnGap: '2rem',
          rowGap: '0.5rem',
          flex: 1,                          
        }}>
          {talkMoves.map((move) => (
            <Box key={move.type} sx={{ display: 'flex', alignItems: 'center', gap: 0.75 }}>
              <Box sx={{
                display: 'flex', alignItems: 'center', justifyContent: 'center',
                width: '1.5rem', height: '1.5rem', flexShrink: 0
              }}>
                {move.type === 'any_talk' ? (
                  <Leaves leaves={[1]} shouldShowLeaf={() => true} />
                ) : (
                  <Flower color={move.color} size={16} />
                )}
              </Box>
              <Typography variant="body2" sx={{ fontSize: '0.875rem', lineHeight: 1.3,   whiteSpace: 'nowrap' }}>
                {move.label}
              </Typography>
            </Box>
          ))}
        </Box>
      </Box>
      </ThemeProvider>
    );
  }
  
  return (
    <ThemeProvider theme={appTheme}>
    <div 
      className="flower-row-wrapper"
      role="figure"
      aria-label={generateAriaLabel()}
    >
      <style>
        {`
    .flower-row-wrapper {
      display: flex;
      width: 100%;
      font-size: 0.875rem;
      font-weight: 400;
    }
    
    .flower-row {
      display: flex;
      flex-direction: row;
      flex-wrap: wrap;
      gap: 0.25rem;
      padding: 0.25rem 0.5rem 0.25rem 0.5rem;
      align-items: flex-start;
      justify-content: flex-start;
      width: fit-content;
    }
    
    .key-label {
      font-size: 0.875rem;
      font-weight: 600;
      margin-right: 0.9375rem;
      color: #333;
    }
    
    .talk-move-item {
      display: flex;
      align-items: center;
      width: fit-content;
      gap: 0.5rem;
      height: 1.5625rem;
      padding: 0.25rem 0.5rem;
      border-radius: 1rem;
      white-space: nowrap;
    }
    
    .flower-container {
      display: flex;
      align-items: center;
      width: 1.5rem; 
      height: 1.5rem; 
      flex-shrink: 0;
    }
    
    .leaf-container {
      display: flex;
      align-items: center;
      justify-content: center;
      width: 1.5rem;
      height: 1.5rem;
      flex-shrink: 0;
      position: relative;
    }
    
    .talk-move-label {
      font-size: 0.875rem;
      font-weight: 400;
    }
    
  `}
      </style>

      <div className="flower-row">
        {talkMoves.map((move) => (
          <div 
            key={move.type} 
            className="talk-move-item"
            role="figure"
            aria-label={`${move.label} represented by a ${move.colorName} ${move.type === 'any_talk' ? 'leaf' : 'flower'}`}
          >
            <div className={move.type === 'any_talk' ? 'leaf-container' : 'flower-container'}>
              {move.type === 'any_talk' ? (
                <Leaves leaves={[1]} shouldShowLeaf={() => true} />
              ) : (
                <Flower color={move.color} size={20} />
              )}
            </div>
            <span className="talk-move-label">{move.label}</span>
          </div>
        ))}
      </div>
    </div>
    </ThemeProvider>
  );
};

export default FlowerTable;
